export const ALL_UPDATE = 'PARAMETRIZATION/ALL/UPDATE';
export const GENERIC_UPDATE = 'PARAMETRIZATION/GENERIC/UPDATE';
export const RESET = 'PARAMETRIZATION/RESET';
